// @flow
import styled from 'styled-components';

export const Wrapper = styled.div`
  position: fixed;
  padding: 20px 0;
  z-index: 100;
  top: 0px;
  left: 0px;
  right: 0px;
  background-color: ${props => props.theme.colors.black};
`;

export const Logo = styled.div`
  font-weight: bold;
  color: white;
  font-size: 24px;
  font-family: ${props => props.theme.fontBold};
  cursor: pointer;
  &:hover {
    text-decoration: underline;
    text-decoration-color: ${props => props.theme.colors.green};
  }
`;

export const Left = styled.div`
  display: inline-block;
  width: 50%;
`;

export const Right = styled(Left)`
  text-align: right;
`;

export const NavLink = styled.a`
  color: white;
  text-decoration: none;
  font-family: ${props => props.theme.fontBold};
  padding: 0 20px;
  font-size: 16px;
  &:hover {
    text-decoration: underline;
    text-decoration-color: ${props => props.theme.colors.green};
  }
`;



// WEBPACK FOOTER //
// ./src/components/nav-bar/nav-bar.styles.js